import React, { useState } from 'react';
import { Button, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from "@nextui-org/react";
import { useNavigate } from 'react-router-dom';
import CanvasJSReact from '@canvasjs/react-charts';

const Dashboard1 = () => {
  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = useState("Today"); // Default filter

  const handleChennaiClick = () => {
    navigate('/greece/chennaidashboard');
  };

  const handleFilterChange = (key) => {
    setSelectedFilter(key);
  };
  var CanvasJS = CanvasJSReact.CanvasJS;
  var CanvasJSChart = CanvasJSReact.CanvasJSChart;


  // Function to return data based on selected filter
  const getPieChartData = () => {
    switch (selectedFilter) {
      case "Week":
        return [
          { y: 20, label: "MECH" },
          { y: 25, label: "IT" },
          { y: 15, label: "ECE" },
          { y: 30, label: "AIDS" },
          { y: 10, label: "CSE" },
        ];
      case "Month":
        return [
          { y: 10, label: "MECH" },
          { y: 20, label: "IT" },
          { y: 30, label: "ECE" },
          { y: 25, label: "AIDS" },
          { y: 15, label: "CSE" },
        ];
      case "Year":
        return [
          { y: 25, label: "MECH" },
          { y: 35, label: "IT" },
          { y: 20, label: "ECE" },
          { y: 10, label: "AIDS" },
          { y: 10, label: "CSE" },
        ];
      default: // Today
        return [
          { y: 18, label: "MECH" },
          { y: 15, label: "IT" },
          { y: 9, label: "ECE" },
          { y: 30, label: "AIDS" },
          { y: 40, label: "CSE" },
        ];
    }
  };

  const getColumnChartData = () => {
    switch (selectedFilter) {
      case "Week":
        return [
          { label: "Canteen 1", y: 40 },
          { label: "Canteen 2", y: 20 },
          { label: "Canteen 3", y: 30 },
          { label: "Canteen 4", y: 10 },
        ];
      case "Month":
        return [
          { label: "Canteen 1", y: 50 },
          { label: "Canteen 2", y: 30 },
          { label: "Canteen 3", y: 20 },
          { label: "Canteen 4", y: 40 },
        ];
      case "Year":
        return [
          { label: "Canteen 1", y: 60 },
          { label: "Canteen 2", y: 35 },
          { label: "Canteen 3", y: 25 },
          { label: "Canteen 4", y: 50 },
        ];
      default: // Today
        return [
          { label: "Canteen 1", y: 35 },
          { label: "Canteen 2", y: 15 },
          { label: "Canteen 3", y: 40 },
          { label: "Canteen 4", y: 10 },
        ];
    }
  };

  const pieChartOptions = {
    exportEnabled: true,
    animationEnabled: true,
    title: {
      text: "Card Usage"
    },
    data: [{
      type: "pie",
      startAngle: 75,
      toolTipContent: "<b>{label}</b>: {y}%",
      showInLegend: "true",
      legendText: "{label}",
      indexLabelFontSize: 16,
      indexLabel: "{label} - {y}%",
      dataPoints: getPieChartData()
    }]
  };

  const columnChartOptions = {
    title: {
      text: "Canteen Sales Details"
    },
    data: [{
      type: "column",
      dataPoints: getColumnChartData()
    }]
  };

  return (
    <>
      <div className="main-inner-wrapper dashboard-wrapper">

        <div className="px-4">
          {/* <div className="leave-apply__wrapper p-4 bg-white dark:bg-neutral-800 border border-gray-300 dark:border-gray-500 rounded-xl"> */}
          <div className="flex justify-between gap-4">
            <h1 className="incident-report-heading ">Dashboard</h1>
            <Dropdown>
              <DropdownTrigger>
                <Button flat>Filter: {selectedFilter}</Button>
              </DropdownTrigger>
              <DropdownMenu aria-label="Dynamic filter" onAction={handleFilterChange}>
                <DropdownItem key="Today">Today</DropdownItem>
                <DropdownItem key="Week">This Week</DropdownItem>
                <DropdownItem key="Month">This Month</DropdownItem>
                <DropdownItem key="Year">This Year</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div className="grid md:grid-cols-2 gap-0 lg:gap-0 px-2 ">
            <div className="col-span-1 p-4">
              <CanvasJSChart options={pieChartOptions} />
            </div>
            <div className="col-span-1 p-4">
              <CanvasJSChart options={columnChartOptions} />
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default Dashboard1;

